<template>
  <div class="app-container">
    <div v-if="platformNotifications.length" class="notifications-container">
      <PlatformNotifications />
    </div>
    <div class="router-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import { onMounted, watch, ref } from 'vue';
import { useStore } from 'vuex';
import { useAuth0 } from '@auth0/auth0-vue';
import { useI18n } from 'vue-i18n';
import useDetectOS from '~/composables/useDetectOS';
import usePlatformNotifications from '~/composables/usePlatformNotifications';
import PlatformNotifications from '~/components/conversation/platformNotifications/PlatformNotifications.vue';

export default {
  name: 'App',
  components: { PlatformNotifications },
  setup() {
    const auth0 = useAuth0();
    const { locale, setLocaleMessage } = useI18n();
    const store = useStore();
    const { platformNotifications } = usePlatformNotifications();

    const { isWindows } = useDetectOS();

    const selectedPage = ref(0);

    const selectedPages = [{ title: 'Assist' }, { title: 'Author' }];

    // this will be moved or refactored once the be is ready
    const loadLocalization = async () => {
      const selectedLocale = locale.value;

      try {
        const dbMessages = {};

        // Merge dynamic messages with default locale
        const defaultMessages = await import(`./locales/${selectedLocale}.json`);
        const mergedMessages = { ...defaultMessages.default, ...dbMessages };

        // Set the locale messages
        setLocaleMessage(selectedLocale, mergedMessages);
        locale.value = selectedLocale;
      } catch (error) {
        console.error('Failed to load messages:', error);
      }
    };

    onMounted(async () => {
      // add custom style for windows scrollbars
      if (isWindows()) {
        document.body.classList.add('custom-scrollbar-windows');
      }
      store.dispatch('auth0Store/setAuth', auth0);
      await loadLocalization();
    });

    watch(
      () => auth0,
      async (newValue) => {
        // logic to execute after DOM updates
        await store.dispatch('auth0Store/setAuth', newValue);
      },
      { immediate: true, deep: true },
    );

    return {
      selectedPages,
      selectedPage,
      platformNotifications,
      locale,
    };
  },
};
</script>

<style lang="scss">
/* Custom scrollbar styling */
.custom-scrollbar-windows {
  ::-webkit-scrollbar {
    width: $bb-spacing-1; /* or any thin size you prefer */
    height: $bb-spacing-1;
  }

  ::-webkit-scrollbar-track {
    background: transparent; /* Light padding zones at ends */
  }

  ::-webkit-scrollbar-thumb {
    background: #888; /* Or any color you prefer */
    border-radius: $bb-spacing-3;
  }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.notifications-container {
  flex: 0 0 auto;
}

.router-container {
  flex: 1 1 auto;
  overflow: auto;
}
</style>
